import arrowRight from "../../assets/home/icon-arrow-right.svg";
import { SectionHeader } from "./shared";
import ellipse1 from "../../assets/home/trust-ellipse1.svg";
import ellipse2 from "../../assets/home/trust-ellipse2.svg";
import ellipse3 from "../../assets/home/trust-ellipse3.svg";
import ellipse4 from "../../assets/home/trust-ellipse4.svg";
import shieldIcon from "../../assets/home/trust-shield.svg";
import buildingIcon from "../../assets/home/trust-building.svg";
import fileIcon from "../../assets/home/trust-file.svg";

const TILES = ["Loan Terms", "Applicable Charges", "Loan Disclosures"];

export default function HomeTrust() {
  return (
    <section className="bg-[#f8fafc] px-4 sm:px-6 lg:px-[80px] py-[60px]">
      <div className="max-w-[1280px] mx-auto flex flex-col items-center gap-8 bg-white border border-[#f3f4f6] rounded-[32px] p-5 sm:p-10 lg:p-16">
        <SectionHeader badge="Lending Partner & Trust" title="Lending Partner and Trust" />

        <div className="w-full flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">
          <div className="relative w-full lg:w-[520px] shrink-0 lg:h-[360px] flex flex-col p-4 sm:p-6 bg-[#f8fafc] border border-[#f3f4f6] rounded-[28px] overflow-hidden">
            <img alt="" src={ellipse1} className="absolute left-[-41px] top-[-41px] size-[220px] pointer-events-none" />
            <img alt="" src={ellipse2} className="absolute right-[-61px] bottom-[-81px] size-[280px] pointer-events-none" />
            <div className="relative flex-1 flex flex-col gap-5 bg-white border border-[#f3f4f6] rounded-[24px] p-6 drop-shadow-[0px_16px_20px_rgba(92,22,138,0.07)]">
              <div className="flex items-center justify-between">
                <span className="bg-[#ecfdf5] px-3 py-1.5 rounded-full font-extrabold text-[#10b981] text-[12px] tracking-[1px] uppercase">
                  Secure lending
                </span>
                <span className="flex items-center justify-center size-10 rounded-full bg-[#fce7f3]">
                  <img alt="" src={shieldIcon} className="size-5" />
                </span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                <div className="flex-1 min-w-0 flex flex-col gap-2">
                  <p className="font-bold text-[#1a1a4b] text-[24px] leading-[30px]">Clear terms, trusted partners</p>
                  <p className="text-[#5b168c] text-[14px] leading-[20px]">Review loan details, charges, and disclosures before you proceed.</p>
                </div>
                <div className="relative shrink-0 size-[180px] bg-[#f8fafc] border border-[#f3f4f6] rounded-[24px] overflow-hidden">
                  <img alt="" src={ellipse3} className="absolute left-[-25px] top-[-25px] size-24 pointer-events-none" />
                  <img alt="" src={ellipse4} className="absolute right-[-29px] bottom-[-29px] size-[88px] pointer-events-none" />
                  <div className="absolute left-[11px] top-[11px] w-[152px] h-[72px] flex flex-col gap-2 bg-white border border-[#f3f4f6] rounded-[16px] p-3">
                    <div className="flex items-center gap-2">
                      <span className="flex items-center justify-center size-7 rounded-full bg-[#ecfdf5]">
                        <img alt="" src={buildingIcon} className="size-[14px]" />
                      </span>
                      <span className="font-bold text-[#1a1a4b] text-[12px]">Partner</span>
                    </div>
                    <p className="text-[#5b168c] text-[11px] leading-[14px]">Trusted lending partner</p>
                  </div>
                  <div className="absolute left-[15px] top-[95px] w-[148px] h-[75px] flex flex-col gap-2 bg-white border border-[#f3f4f6] rounded-[16px] p-3">
                    <div className="flex items-center gap-2">
                      <span className="flex items-center justify-center size-7 rounded-full bg-[#fce7f3]">
                        <img alt="" src={fileIcon} className="size-[14px]" />
                      </span>
                      <span className="font-bold text-[#1a1a4b] text-[12px]">Terms</span>
                    </div>
                    <p className="text-[#5b168c] text-[11px] leading-[14px]">Clear disclosures</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 min-w-0 flex flex-col gap-6 bg-[#f8fafc] border border-[#f3f4f6] rounded-[28px] p-6 sm:p-8">
            <div className="flex flex-col gap-2">
              <p className="font-bold text-[#1a1a4b] text-[24px] leading-[30px]">Everything you need before you apply</p>
              <p className="text-[#5b168c] text-[14px] leading-[20px]">
                Review the key lending details in one place so you can move forward with confidence.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {TILES.map((tile) => (
                <div key={tile} className="flex flex-col gap-1 bg-white border border-[#f3f4f6] rounded-[16px] p-4 sm:min-h-[112px]">
                  <p className="font-extrabold text-[#5b168c] text-[14px] tracking-[0.5px] uppercase">{tile}</p>
                  <p className="text-[#1a1a4b] text-[14px] leading-[20px]">Destination pending confirmation</p>
                </div>
              ))}
            </div>
            <a
              href="/loan-illustrations"
              className="self-start inline-flex items-center justify-center gap-2 px-10 py-4 bg-[#5c168a] rounded-full font-bold text-[14px] text-white tracking-[1px] uppercase whitespace-nowrap transition-opacity hover:opacity-90"
            >
              View Loan Terms
              <img alt="" src={arrowRight} className="size-[14px]" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
